import React, { useEffect, useState } from 'react';

import StatusCapsual from '../../components/DataTable/StatusCapsule';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import DateBox from '../../components/General/DateBox';
import AddEditPerfoma from '../PerfomaSubmission/AddEditPerfoma';
const bgColor = {
  Completed: 'success',
  'In Progress': 'warning',
  Upcoming: 'purple',
};
const DateCardPerfoma = ({
  centers,
  examDats,
  examData,
  centersDats,
  carBgColor = '#fff',
  onClick,
  iscentersReport = false,
  selectedDay = false,
}) => {
  const DEFAULT_DIVISION_MODAL = {
    id: null,
    show: false,
    title: 'Add Perfoma',
    saveBtnText: 'Save',
    action: 'ADD',
  };
  const [centersDate, setcentersDate] = useState({});
  const [userModal, setUserModal] = useState(DEFAULT_DIVISION_MODAL);

  const AddPerfoma = () => {
    setUserModal((preveState) => ({
      ...preveState,
      show: true,
    }));
  };
  // useEffect(() => {
  //   console.log('examDats', examDats.date);
  //   if (examDats?.date) {
  //     formatDate(examDats?.date);
  //   }
  // }, [centers]);
  let cardClassName,
    cardTextClassName,
    cardTextSpanClassName,
    statusBadgeClass = '';
  if (!iscentersReport) {
    cardClassName = `bg-${bgColor[`${centers?.centers_status}`]}-lt-rrb`;
    cardTextClassName = 'text-secondary';
    cardTextSpanClassName = 'text-black';
    statusBadgeClass = `border bg-white text-${
      bgColor[`${centers?.centers_status}`]
    }`;
  } else if (selectedDay === centers.id) {
    cardClassName = `bg-primary`;
    cardTextClassName = 'text-white';
    cardTextSpanClassName = 'text-white';
    statusBadgeClass = `bg-${bgColor[`${centers?.centers_status}`]}`;
  } else {
    cardTextClassName = 'text-secondary';
    cardTextSpanClassName = 'text-black';
    statusBadgeClass = `border bg-${bgColor[`${centers?.centers_status}`]}-lt`;
  }
  const resetUserModal = (isReload = false) => {
    setUserModal(DEFAULT_DIVISION_MODAL);
    if (isReload === true) {
      // fetchUser();
    }
  };
  return (
    <Col xs={12} sm={6} xl={4} xxl={3}>
      <Card
        className={`${cardClassName} card-link`}
        onClick={onClick}
        role='button'
      >
        <Card.Body className='p-3' onClick={AddPerfoma}>
          <Row className='align-items-center'>
            <Col className='col-auto'>
              <DateBox
                date={examDats?.date}
                className={`${!iscentersReport ? 'bg-white' : ''}`}
              />
            </Col>
            <Col className={cardTextClassName}>
              <Card.Text
                className={`mb-1 fs-3 text-truncate ${cardTextClassName}`}
              >
                <span className={`${cardTextSpanClassName}`}>
                  {centers.center.center_code} - {centers.center.center_name}
                </span>
              </Card.Text>
              {/* <Card.Text
                className={`mb-0 fs-3 text-truncate ${cardTextClassName}`}
              >
               {centers?.coordinator?.length > 0 ? (
                  centers.coordinator.map((coordinator, index) => (
                    <div key={index} className='mb-1'>
                      {coordinator?.user?.first_name}{' '}
                      {coordinator?.user?.last_name}
                    </div>
                  ))
                ) : (
                  <>
                    <span
                      className={`${
                        centers?.incidents > 0 ? 'text-danger' : 'text-black'
                      } fw-semibold`}
                    >
                      {centers?.incidents}
                    </span>{' '}
                    Incidents
                  </>
                )}
              </Card.Text> */}
            </Col>
            <Col className='col-auto'>
              <Badge className={`${statusBadgeClass}`}>
                {centers?.centers_status}
              </Badge>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {userModal.show && (
        <AddEditPerfoma {...{ userModal, resetUserModal, examData }} />
      )}
    </Col>
  );
};

export default DateCardPerfoma;
